/**
 * Collection filter drawer — YvesRocherUsa sections/main-collection.liquid (adapted for Premier facet:update)
 */
(function () {
  const DRAWER_ID = 'facets-drawer';

  function getDrawer() {
    return document.getElementById(DRAWER_ID);
  }

  function ensureDrawerClosed() {
    const drawer = getDrawer();
    if (!drawer) return;

    drawer.setAttribute('hidden', '');

    if (drawer.open && typeof drawer.hide === 'function') {
      try {
        drawer.hide();
      } catch (_error) {
        /* drawer may not be upgraded yet */
      }
    }

    drawer.removeAttribute('open');
    drawer.style.setProperty('display', 'none');
  }

  function unlockDrawerForUser() {
    const drawer = getDrawer();
    if (!drawer) return;
    window.__wdFilterDrawerUserOpen = true;
    window.__wdFilterDrawerInitUntil = 0;
    drawer.removeAttribute('hidden');
    drawer.style.removeProperty('display');
  }

  function patchFacetsDrawerShow() {
    const FacetsDrawer = window.customElements?.get('facets-drawer');
    if (!FacetsDrawer?.prototype || FacetsDrawer.prototype.__wdShowPatched) return;

    const originalShow = FacetsDrawer.prototype.show;
    FacetsDrawer.prototype.show = function showWithUserIntent(animate = true) {
      if (!window.__wdFilterDrawerUserOpen && !window.Shopify?.designMode) {
        return Promise.resolve();
      }

      this.removeAttribute('hidden');
      this.style.removeProperty('display');
      return originalShow.call(this, animate);
    };

    FacetsDrawer.prototype.__wdShowPatched = true;
  }

  function closeDrawer(drawer) {
    if (!drawer) return;

    window.__wdFilterDrawerUserOpen = false;

    if (drawer.open && typeof drawer.hide === 'function') {
      drawer.hide();
      return;
    }

    ensureDrawerClosed();
  }

  function bindDrawerClose(drawer) {
    if (!drawer || drawer.dataset.wdCloseBound === 'true') return;
    drawer.dataset.wdCloseBound = 'true';

    drawer.addEventListener('dialog:force-close', () => {
      closeDrawer(drawer);
    });

    drawer.addEventListener(
      'click',
      (event) => {
        if (!drawer.open) return;

        const closeTarget = event.composedPath().find((node) => {
          return (
            node instanceof Element &&
            (node.matches?.('[part="close-button"]') ||
              node.matches?.('[part="close-button tap-area"]') ||
              node.closest?.('[part="close-button"]') ||
              node.closest?.('[part="close-button tap-area"]'))
          );
        });

        if (closeTarget) {
          event.preventDefault();
          closeDrawer(drawer);
        }
      },
      true
    );
  }

  function bindDrawerGuard(drawer) {
    if (!drawer || drawer.dataset.wdDrawerGuard === 'true') return;
    drawer.dataset.wdDrawerGuard = 'true';

    const observer = new MutationObserver(() => {
      if (window.__wdFilterDrawerUserOpen) return;

      const initUntil = window.__wdFilterDrawerInitUntil || 0;
      if (!initUntil || Date.now() > initUntil) {
        observer.disconnect();
        return;
      }

      if (drawer.hasAttribute('open')) {
        ensureDrawerClosed();
      }
    });

    observer.observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }

  function getDrawerPriceRange() {
    return getDrawer()?.querySelector('.price-range');
  }

  function getPriceRangeNumberInputs(priceRange) {
    return priceRange ? Array.from(priceRange.querySelectorAll('.input-group input[type="number"]')) : [];
  }

  function isPriceRangeAtDefault(priceRange) {
    const [minInput, maxInput] = getPriceRangeNumberInputs(priceRange);
    const rangeMin = priceRange?.querySelector('input[type="range"]:first-child');
    const rangeMax = priceRange?.querySelector('input[type="range"]:last-child');
    if (!minInput || !maxInput || !rangeMin || !rangeMax) return true;

    const minBound = Number.parseInt(minInput.min || rangeMin.min || '0', 10);
    const maxBound = Number.parseInt(maxInput.max || rangeMax.max, 10);
    const minVal =
      minInput.value === '' ? Number.parseInt(rangeMin.value, 10) : Number.parseInt(minInput.value, 10);
    const maxVal =
      maxInput.value === '' ? Number.parseInt(rangeMax.value, 10) : Number.parseInt(maxInput.value, 10);

    if (Number.isNaN(minVal) || Number.isNaN(maxVal)) return true;

    return minVal <= minBound && maxVal >= maxBound;
  }

  function resetPriceRangeVisuals(priceRange) {
    if (!priceRange) return;

    const [minInput, maxInput] = getPriceRangeNumberInputs(priceRange);
    const rangeMin = priceRange.querySelector('input[type="range"]:first-child');
    const rangeMax = priceRange.querySelector('input[type="range"]:last-child');
    const rangeGroup = priceRange.querySelector('.range-group');

    if (rangeMin) rangeMin.value = rangeMin.min;
    if (rangeMax) rangeMax.value = rangeMax.max;

    if (minInput) {
      minInput.value = '';
      minInput.removeAttribute('value');
    }
    if (maxInput) {
      maxInput.value = '';
      maxInput.removeAttribute('value');
    }

    if (rangeGroup) {
      rangeGroup.style.setProperty('--range-min', '0%');
      rangeGroup.style.setProperty('--range-max', '100%');
    }

    priceRange.classList.add('wd-default-price-filter');
  }

  function clearPriceRangeInDrawer() {
    const priceRange = getDrawerPriceRange();
    if (!priceRange) return;

    resetPriceRangeVisuals(priceRange);
  }

  function applyPriceRangeTrackStyles(priceRange) {
    const [minInput, maxInput] = getPriceRangeNumberInputs(priceRange);
    const rangeMin = priceRange.querySelector('input[type="range"]:first-child');
    const rangeMax = priceRange.querySelector('input[type="range"]:last-child');
    const rangeGroup = priceRange.querySelector('.range-group');

    if (!rangeMin || !rangeMax || !rangeGroup) return;

    const rangeMaxNum = Number.parseInt(rangeMax.max, 10) || 1;
    const minBound = Number.parseInt(rangeMin.min, 10) || 0;
    const maxBound = Number.parseInt(rangeMax.max, 10);

    let minVal =
      minInput?.value !== ''
        ? Number.parseInt(minInput.value, 10)
        : Number.parseInt(rangeMin.value, 10);
    let maxVal =
      maxInput?.value !== ''
        ? Number.parseInt(maxInput.value, 10)
        : Number.parseInt(rangeMax.value, 10);

    if (Number.isNaN(minVal)) minVal = minBound;
    if (Number.isNaN(maxVal)) maxVal = maxBound;

    minVal = Math.max(minBound, Math.min(minVal, maxBound));
    maxVal = Math.max(minVal, Math.min(maxVal, maxBound));

    rangeMin.value = String(minVal);
    rangeMax.value = String(maxVal);

    rangeGroup.style.setProperty('--range-min', `${(minVal / rangeMaxNum) * 100}%`);
    rangeGroup.style.setProperty('--range-max', `${(maxVal / rangeMaxNum) * 100}%`);
  }

  function syncPriceRangeVisuals(priceRange) {
    if (!priceRange) return;

    if (isPriceRangeAtDefault(priceRange)) {
      priceRange.classList.add('wd-default-price-filter');
      applyPriceRangeTrackStyles(priceRange);
      return;
    }

    priceRange.classList.remove('wd-default-price-filter');
    applyPriceRangeTrackStyles(priceRange);
  }

  function fakeClickActiveFiltersInDrawer() {
    const footerContainer = document.querySelectorAll('.wd-filter-drawer div[slot="footer"] .wd-fake-active-focets');

    footerContainer.forEach((fakeActiveFocet) => {
      if (fakeActiveFocet.dataset.wdBound === 'true') return;
      fakeActiveFocet.dataset.wdBound = 'true';

      let realRemoveFilter;
      const href = fakeActiveFocet.getAttribute('href');
      const filterKey = fakeActiveFocet.dataset.filterkey;

      if (fakeActiveFocet.classList.contains('wd-price-range')) {
        fakeActiveFocet.addEventListener('click', (event) => {
          event.preventDefault();
          clearPriceRangeInDrawer();

          const facetsForm = getDrawer()?.querySelector('facets-form');
          const previewUrl = facetsForm ? buildFacetsPreviewUrl(facetsForm) : null;

          if (previewUrl) {
            updateButtonProductCount(previewUrl);
          } else if (href) {
            window.location.assign(href);
          }

          numberOfActiveFiltersInAccordion();
        });
        return;
      } else if (filterKey) {
        realRemoveFilter = document.querySelector(
          `.wd-filters-wrapper input[data-filterkey="${CSS.escape(filterKey)}"], .wd-filter-availability input[data-filterkey="${CSS.escape(filterKey)}"]`
        );
      } else if (fakeActiveFocet.dataset.filterlabel) {
        realRemoveFilter = document.querySelector(
          `.wd-filters-wrapper input[data-labelname="${CSS.escape(fakeActiveFocet.dataset.filterlabel)}"]`
        );
      }

      fakeActiveFocet.addEventListener('click', (event) => {
        event.preventDefault();
        if (realRemoveFilter) {
          realRemoveFilter.click();
          fakeActiveFocet.parentElement?.remove();
          return;
        }
        if (href) {
          window.location.assign(href);
        }
      });
    });
  }

  const ACCORDION_CHEVRON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none" class="icon group-expanded:rotate" aria-hidden="true">
    <path d="M1 1L6 7L11 1" stroke="#111111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`;

  function getFilterDrawerAccordions() {
    return document.querySelectorAll('.wd-filter-drawer .accordion-list > .accordion');
  }

  function getAccordionToggleChevron(accordionElem) {
    return (
      accordionElem.querySelector('.accordion__toggle > svg.icon') ||
      accordionElem.querySelector('.accordion__toggle svg:last-of-type')
    );
  }

  function ensureAccordionCountBadge(accordionElem, count) {
    const accordionHeaderSvg = getAccordionToggleChevron(accordionElem);
    if (!accordionHeaderSvg) return;

    let existingCountElem = accordionElem.querySelector('.wd-active-filter-count');
    let wrapperDiv = accordionElem.querySelector('.wd-svg-number-wrapper');

    if (!wrapperDiv) {
      wrapperDiv = document.createElement('div');
      wrapperDiv.classList.add('wd-svg-number-wrapper');
      accordionHeaderSvg.parentNode.insertBefore(wrapperDiv, accordionHeaderSvg);
      wrapperDiv.appendChild(accordionHeaderSvg);
    }

    if (!existingCountElem) {
      existingCountElem = document.createElement('span');
      existingCountElem.classList.add('wd-active-filter-count');
      wrapperDiv.appendChild(existingCountElem);
    }

    existingCountElem.textContent = String(count);
  }

  function removeAccordionCountBadge(accordionElem) {
    accordionElem.querySelector('.wd-active-filter-count')?.remove();
    const wrapper = accordionElem.querySelector('.wd-svg-number-wrapper');
    const accordionHeaderSvg = getAccordionToggleChevron(accordionElem);

    if (wrapper && accordionHeaderSvg && wrapper.contains(accordionHeaderSvg)) {
      wrapper.parentNode.insertBefore(accordionHeaderSvg, wrapper);
      wrapper.remove();
    }
  }

  function numberOfActiveFiltersInAccordion() {
    getFilterDrawerAccordions().forEach((accordionElem) => {
      const accordionHeaderSvg = getAccordionToggleChevron(accordionElem);
      if (!accordionHeaderSvg) return;

      const activeCheckboxFilters = accordionElem.querySelectorAll(
        '.checkbox-control.wd-filters-wrapper input:checked'
      );
      const activeSwitchFilters = accordionElem.querySelectorAll('.wd-filter-availability input:checked');
      const activePriceRangeFilters = accordionElem.querySelector('.price-range');
      let activeFiltersCount = 0;

      if (activeCheckboxFilters.length > 0) {
        activeFiltersCount = activeCheckboxFilters.length;
      } else if (activeSwitchFilters.length > 0) {
        activeFiltersCount = activeSwitchFilters.length;
      } else if (activePriceRangeFilters) {
        if (isPriceRangeAtDefault(activePriceRangeFilters)) {
          removeAccordionCountBadge(accordionElem);
          accordionHeaderSvg.outerHTML = ACCORDION_CHEVRON_SVG;
          return;
        }

        activeFiltersCount = 1;
      }

      if (activeFiltersCount > 0) {
        ensureAccordionCountBadge(accordionElem, activeFiltersCount);
      } else {
        removeAccordionCountBadge(accordionElem);
      }

      const refreshedChevron = getAccordionToggleChevron(accordionElem);
      if (refreshedChevron && !refreshedChevron.closest('.wd-svg-number-wrapper')) {
        refreshedChevron.outerHTML = ACCORDION_CHEVRON_SVG;
      }
    });
  }

  function syncDrawerFooterState() {
    const drawer = getDrawer();
    if (!drawer) return;

    const hasActiveFacets = Boolean(drawer.querySelector('div[slot="footer"] .active-facets .removable-facet'));
    drawer.classList.toggle('wd-has-active-facets', hasActiveFacets);
  }

  async function updateButtonProductCount(url) {
    try {
      const response = await fetch(url);
      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');

      const productActiveFiltersElement = doc.querySelector('.active-facets');
      const allActiveFocetsWrapper = document.querySelector('.wd-filter-drawer div[slot="footer"] .active-facets');
      const filterDrawerFooter = document.querySelector('.wd-filter-drawer div[slot="footer"]');

      if (productActiveFiltersElement && allActiveFocetsWrapper) {
        allActiveFocetsWrapper.remove();
        filterDrawerFooter?.append(productActiveFiltersElement);
        fakeClickActiveFiltersInDrawer();
      } else if (productActiveFiltersElement && filterDrawerFooter) {
        filterDrawerFooter.append(productActiveFiltersElement);
        fakeClickActiveFiltersInDrawer();
      } else if (allActiveFocetsWrapper) {
        allActiveFocetsWrapper.remove();
      }

      const productCountElement = doc.querySelector('.collection-toolbar__products-count');
      const buttonElement = document.querySelector('.wd-filter-drawer div[slot="footer"] .wd-filter-drawer-apply-btn');

      if (productCountElement && buttonElement) {
        const productCount = productCountElement.textContent.trim().split(' ')[0];
        buttonElement.textContent = `View ${productCount} products`;
      }

      syncDrawerFooterState();
    } catch (error) {
      console.error('Error fetching filter preview:', error);
    }
  }

  function buildFacetsPreviewUrl(facetsForm) {
    const form = facetsForm.querySelector('form');
    if (!form) return null;

    const priceRange = getDrawerPriceRange();

    const searchParams = new URLSearchParams(new FormData(form));
    const url = new URL(form.action || window.location.href);
    url.search = '';
    searchParams.forEach((value, key) => url.searchParams.append(key, value));
    ['page', 'filter.v.price.gte', 'filter.v.price.lte'].forEach((optionToClear) => {
      if (url.searchParams.get(optionToClear) === '') {
        url.searchParams.delete(optionToClear);
      }
    });

    if (priceRange && isPriceRangeAtDefault(priceRange)) {
      url.searchParams.delete('filter.v.price.gte');
      url.searchParams.delete('filter.v.price.lte');
    }
    url.searchParams.set('section_id', facetsForm.getAttribute('section-id'));
    return url.toString();
  }

  function runDrawerEnhancements() {
    if (!getDrawer()) return;
    numberOfActiveFiltersInAccordion();
    fakeClickActiveFiltersInDrawer();
    syncDrawerFooterState();
  }

  function initDrawer() {
    patchFacetsDrawerShow();

    const drawer = getDrawer();
    if (!drawer) return;

    if (!window.__wdFilterDrawerSetupDone) {
      window.__wdFilterDrawerSetupDone = true;
      window.__wdFilterDrawerInitUntil = Date.now() + 800;
      ensureDrawerClosed();
      bindDrawerClose(drawer);
      bindDrawerGuard(drawer);
    }

    runDrawerEnhancements();
  }

  function onDrawerFormChange(event) {
    const facetsForm = event.target.closest('.wd-filter-drawer facets-form');
    if (!facetsForm) return;

    const priceRange = getDrawerPriceRange();
    if (priceRange && event.target.closest('.price-range')) {
      const sync = () => syncPriceRangeVisuals(priceRange);

      if (event.type === 'change') {
        requestAnimationFrame(sync);
      } else if (event.target.matches('.input-group input[type="number"]')) {
        sync();
      }
    }

    const url = buildFacetsPreviewUrl(facetsForm);
    if (url) {
      updateButtonProductCount(url);
      numberOfActiveFiltersInAccordion();
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      if (event.target.closest('[aria-controls="facets-drawer"]')) {
        unlockDrawerForUser();
      }
    },
    true
  );

  document.addEventListener('dialog:after-hide', (event) => {
    if (!event.target?.classList?.contains('wd-filter-drawer')) return;
    window.__wdFilterDrawerUserOpen = false;
    ensureDrawerClosed();
  });

  document.addEventListener('DOMContentLoaded', initDrawer);
  window.addEventListener('load', initDrawer);
  window.customElements?.whenDefined('facets-drawer').then(initDrawer);

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target?.querySelector?.(`#${DRAWER_ID}`) || event.target?.querySelector?.('.wd-filter-drawer')) {
      initDrawer();
    }
  });

  document.addEventListener('change', onDrawerFormChange);
  document.addEventListener('input', onDrawerFormChange);

  document.addEventListener('facet:update', () => {
    requestAnimationFrame(runDrawerEnhancements);
  });

  document.addEventListener('dialog:after-show', (event) => {
    if (!event.target?.classList?.contains('wd-filter-drawer')) return;

    const initUntil = window.__wdFilterDrawerInitUntil || 0;
    if (!window.__wdFilterDrawerUserOpen && initUntil && Date.now() < initUntil) {
      ensureDrawerClosed();
      return;
    }

    runDrawerEnhancements();
  });
})();
